import "../styles/default.scss";

import qs from "qs";
import React from "react";
import { Redirect } from "react-router";
import { compose } from "redux";

import { UrlProvider } from "../../../../../api/UrlProvider";
import { getLoginWithRedirectUrl } from "../../../../../lib/auth/authRedirectUrl";
import withMobileMediaQuery from "../../../../../hocs/withMobileMediaQuery";
import withPortfoliosList from "../../../../../hocs/withPortfoliosList";
import withUserData from "../../../../../hocs/withUserData";
import { PLAN_PERMISSIONS_NAMES } from "../../../../../redux/modules/auth/userPermissions/selector";
import ContentSection from "../../../common/ContentSection";
import NoPortfolios from "../../../common/NoPortfolios";
import Portfolio from "../../../common/Portfolio";
import PortfoliosError from "../../../common/PortfoliosError";
import PortfoliosList from "../../../common/PortfoliosList";
import SquaberButton from "../../../common/SquaberButton";
import SquaberLink from "../../../common/SquaberLink/modules/default";
import UpgradePlansWrapper from "../../../landingPage/pages/Plans/components/UpgradePlanWrapper";

class PortfoliosPage extends React.Component {
  render() {
    const {
      locale,
      match: {
        params: { portfolioId }
      },
      location: { search },
      portfoliosListState,
      userData,
      isMobileMediaQuery,
      hasPermission,
      translate
    } = this.props;

    let shouldAttemptRedirect = true;

    const searchParams = qs.parse(search.replace("?", ""));

    if (!userData || searchParams.no_redirect) {
      shouldAttemptRedirect = false;
    }

    const shouldShowNoPortfolios =
      !userData ||
      (!portfoliosListState.loading &&
        portfoliosListState.data &&
        portfoliosListState.data.portfolios.length === 0);

    if (
      shouldAttemptRedirect &&
      !portfolioId &&
      portfoliosListState.data &&
      portfoliosListState.data.portfolios.length
    ) {
      return (
        <Redirect
          to={UrlProvider.getUrl("fe.portfolio", {
            locale,
            id: portfoliosListState.data.portfolios[0].id
          })}
        />
      );
    }

    const permissions =
      portfoliosListState?.data?.error?.response?.data?.permissions;

    if (
      !portfoliosListState.loading &&
      Array.isArray(permissions) &&
      !hasPermission(permissions)
    ) {
      return (
        <div className="portfolios-page">
          <div className={"portfolios-page-upgrade-plan"}>
            <UpgradePlansWrapper
              permissions={[PLAN_PERMISSIONS_NAMES.PORTFOLIO]}
            />
          </div>
        </div>
      );
    }

    if (portfoliosListState.error) {
      if (portfoliosListState.error === "Missing auth token") {
        return (
          <div className="portfolios-page">
            <ContentSection className="portfolios-error">
              <h1>{translate("Portfolio")}</h1>
              <p>{translate("portfolio_missing_auth_token")}</p>
              <SquaberLink to={getLoginWithRedirectUrl({ locale })}>
                <SquaberButton>{translate("Log in")}</SquaberButton>
              </SquaberLink>
            </ContentSection>
          </div>
        );
      }

      return (
        <div className="portfolios-page">
          <PortfoliosError />
        </div>
      );
    }

    return (
      <div className="portfolios-page">
        {!isMobileMediaQuery ? (
          <div className="portfolios-page-sidebar">
            <PortfoliosList
              current={portfolioId}
              portfoliosListState={portfoliosListState}
            />
          </div>
        ) : null}
        <div className="portfolios-page-content">
          {shouldShowNoPortfolios ? (
            <NoPortfolios />
          ) : portfolioId ? (
            <Portfolio id={portfolioId} key={portfolioId} />
          ) : null}
        </div>
      </div>
    );
  }
}

export default compose(
  withUserData,
  withPortfoliosList,
  withMobileMediaQuery
)(PortfoliosPage);
